import type { DocumentPreviewInput } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function useDownloadDocument() {
  const api = useOsApi()

  async function downloadDocument(request: DocumentPreviewInput) {
    const result = await api.post('/documents/:documentType/preview', {
      params: { documentType: request.documentType },
      body: request.input,
    })
    if (result.success) {
      const url = URL.createObjectURL(result.data)
      const link = document.createElement('a')
      link.href = url
      link.download = result.data.name
      link.click()
      setTimeout(() => URL.revokeObjectURL(url), 30_000)
    }
    return result
  }

  return { downloadDocument }
}
